var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.347656,
    width: 24,
    height: 24,
    rx: 10,
    fill: "#1D1E25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.74 11.7C11.3422 11.7 10.9607 11.542 10.6794 11.2607C10.3981 10.9794 10.24 10.5978 10.24 10.2C10.24 9.80218 10.3981 9.42064 10.6794 9.13934C10.9607 8.85804 11.3422 8.7 11.74 8.7C12.1379 8.7 12.5194 8.85804 12.8007 9.13934C13.082 9.42064 13.24 9.80218 13.24 10.2C13.24 10.5978 13.082 10.9794 12.8007 11.2607C12.5194 11.542 12.1379 11.7 11.74 11.7ZM7.54004 10.2C7.54004 13.35 11.74 18 11.74 18C11.74 18 15.94 13.35 15.94 10.2C15.94 7.878 14.062 6 11.74 6C9.41804 6 7.54004 7.878 7.54004 10.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language_icon.44c62de8ae28cd1c7fe3bddafd95e5ec.svg";
export { ForwardRef as ReactComponent };